import {Injectable} from "@angular/core";
import {GenericService} from "../../core/commons/generic.service";
import {Abogado} from "../domain/abogado";
import {AuthService} from "../../core/security/auth.service";
import {QueryOptions} from "../../core/commons/query.options";
import {AbogadoMessage} from "../domain/abogado-message";
import {Observable} from "rxjs/Observable";
import {RequestMethod} from "@angular/http";
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class AbogadosService extends GenericService<Abogado> {

    private messagePath = '/message'

    constructor(authService: AuthService) {
        super(authService)
    }

    protected valueToEntity(value: Object): Abogado {
        return new Abogado(value);
    }

    protected getResourcePath(): string {
        return '/abogados';
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public sendMessage(message: AbogadoMessage): Observable<boolean> {
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + this.messagePath,
            this.buildRequest(RequestMethod.Post, JSON.stringify(message)))
            .map(res => true)
            .catch(err => Observable.of(false));
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/abogados.service.ts